(() => {
  if (window.damV10Home) { window.damV10Home.init(); return; }
  const instances = new Map();
  function init(scope = document) {
    for (const [home, instance] of instances) if (!home.isConnected) { instance.dispose(); instances.delete(home); }
    const homes = [...(scope.matches?.('.dam-v10-home') ? [scope] : []), ...scope.querySelectorAll('.dam-v10-home')];
    for (const home of homes) {
      if (instances.has(home)) continue;
      const controller = new AbortController();
      const observers = [];
      const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, {...options, signal: controller.signal});
      instances.set(home, {dispose: () => { controller.abort(); observers.forEach(observer => observer.disconnect()); }});
      home.dataset.initialized = 'true';
      const loadScene = (card) => {
        const holder = card.querySelector('[data-scene-src]');
        if (!holder || holder.dataset.loaded === '1' || holder.tagName === 'IMG') return;
        const img = document.createElement('img');
        img.className = holder.className;
        img.alt = holder.dataset.sceneAlt || '';
        img.decoding = 'async';
        img.src = holder.dataset.sceneSrc;
        img.dataset.loaded = '1';
        holder.replaceWith(img);
      };
      for (const card of home.querySelectorAll('.dam-v10-pcard')) {
        if (!card.querySelector('[data-scene-src]')) continue;
        on(card, 'pointerenter', () => loadScene(card), { once: true });
        on(card, 'focusin', () => loadScene(card), { once: true });
      }
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      for (const section of home.querySelectorAll('.dam-v10-products-section,.dam-v10-process-mobile,.dam-v10-guides-section,.dam-v10-blog-section,.dam-v10-painter-stories')) {
        const track = section.querySelector('.dam-v10-product-track,.dam-v10-process-mobile-track,.dam-v10-guide-track,.dam-v10-blog-track,.dam-v10-quote-grid');
        if (!track) continue;
        const controls = [...section.querySelectorAll('[data-carousel-dir]')];
        const refresh = () => {
          controls.forEach(b => b.disabled = Number(b.dataset.carouselDir) < 0 ? track.scrollLeft < 2 : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
          const progress = section.querySelector('.dam-v10-track-progress i');
          if (progress) progress.style.width = `${100 * Math.min(1, (track.scrollLeft + track.clientWidth) / Math.max(1, track.scrollWidth))}%`;
        };
        controls.forEach(b => on(b, 'click', () => {
          const item = track.firstElementChild;
          if (item) track.scrollBy({left: Number(b.dataset.carouselDir) * (item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0)), behavior: behavior()});
        }));
        if (section.matches('.dam-v10-painter-stories')) on(track, 'keydown', event => {
          if (event.target !== track) return;
          const item = track.firstElementChild;
          if (!item || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            track.scrollTo({left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: behavior()});
          } else {
            const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
            track.scrollBy({left: event.key === 'ArrowLeft' ? -step : step, behavior: behavior()});
          }
        });
        on(track, 'scroll', refresh, {passive: true});
        const observer = new ResizeObserver(refresh);
        observer.observe(track); observers.push(observer);
        refresh();
      }
      for (const button of home.querySelectorAll('[data-process-step]')) on(button, 'click', () => {
        const image = home.querySelector('#process-image');
        image.src = button.dataset.processImage;
        image.alt = button.querySelector('strong').textContent;
        home.querySelector('#process-caption').textContent = button.querySelector('span > span').textContent;
        home.querySelectorAll('[data-process-step]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
      const more = home.querySelector('#read-more');
      on(more, 'click', () => {
        const expanded = more.getAttribute('aria-expanded') === 'true';
        more.setAttribute('aria-expanded', String(!expanded));
        home.querySelector('#more-copy').hidden = expanded;
      });
    }
  }
  window.damV10Home = {init};
  const disposeWithin = scope => {
    for (const [home, instance] of instances) if (scope.contains(home)) { instance.dispose(); instances.delete(home); }
  };
  init();
  document.addEventListener('shopify:section:load', event => { disposeWithin(event.target); init(event.target); });
  document.addEventListener('shopify:section:unload', event => disposeWithin(event.target));
  window.addEventListener('pageshow', init.bind(null, document));
})();
